import React__default from 'react';

var IconBlock = function (_a) {
    var iconType = _a.iconType;
    return React__default.createElement("i", { className: "ui-lib-".concat(iconType) });
};

export { IconBlock };
